// utils/dimensional-templates.js
export const DimensionalLongitudinal = {
    familyId: 'dimensional',
    subfamilyId: 'longitudinal',
    subtypes: {
      caliper: {
        id: 'dim-long:caliper',
        label: 'Calibre (pie de rey)',
        unit: 'mm',
        minPoints: 5,
        suggestSetpoints: (rangeMin, rangeMax) => {
          const rMin = Number(rangeMin ?? 0);
          const rMax = Number(rangeMax ?? 150);
          const span = rMax - rMin;
          return [0, 0.1, 0.5, 0.8, 1].map(p => +(rMin + span * p).toFixed(2));
        },
        columns: [
          { id: 'setpoint', label: 'Setpoint', type: 'number' },
          { id: 'r1', label: 'Lectura 1', type: 'number' },
          { id: 'r2', label: 'Lectura 2', type: 'number' },
        ]
      },
      micrometer: {
        id: 'dim-long:micrometer',
        label: 'Micrómetro',
        unit: 'µm', // si prefieren mm, cambiar aquí
        minPoints: 6,
        suggestSetpoints: (rangeMin, rangeMax) => {
          const rMin = Number(rangeMin ?? 0);
          const rMax = Number(rangeMax ?? 25);
          return [rMin, rMin+5, rMin+10, rMin+15, rMin+20, rMax].map(v => +v.toFixed(2));
        },
        columns: [
          { id: 'setpoint', label: 'Setpoint', type: 'number' },
          { id: 'r1', label: 'Lectura 1', type: 'number' },
          { id: 'r2', label: 'Lectura 2', type: 'number' },
          { id: 'r3', label: 'Lectura 3', type: 'number' },
        ]
      },
      rule: {
        id: 'dim-long:rule',
        label: 'Regla / Flexómetro',
        unit: 'mm',
        minPoints: 5,
        suggestSetpoints: (rangeMin, rangeMax) => {
          const rMin = Number(rangeMin ?? 0);
          const rMax = Number(rangeMax ?? 5000);
          const pts = [rMin];
          for (let m = 500; m <= rMax; m += 500) pts.push(m);
          return pts.slice(0, 10);
        },
        columns: [
          { id: 'setpoint', label: 'Marca nominal', type: 'number' },
          { id: 'r1', label: 'Lectura', type: 'number' },
        ]
      }
    }
  };
  